import React from 'react'
import { Avatar, Card, Col, Divider, Row, Typography } from 'antd'
import { Passport as PassportData } from '../../../services/api/documents'
import { UserOutlined } from '@ant-design/icons'
import { CardProps } from 'antd/lib/card'

const { Text } = Typography
const style = {
  color: '#FF9100',
  background: '#FFF5C7',
}
type Props = CardProps & PassportData

export const Passport: React.FunctionComponent<Props> = (props) => {
  const { firstName, middleName, lastName, number, ...properties } = props
  const fullName: string = `${firstName} ${middleName || ''} ${lastName}`
  const formattedNumber: string = [number.slice(0, 4), number.slice(4)].join(
    ' '
  )

  return (
    <Card title="Паспорт" bordered {...properties}>
      <Row gutter={10} align="middle">
        <Col span={6}>
          <Avatar size="large" style={style}>
            <UserOutlined />
          </Avatar>
        </Col>
        <Col span={18}>
          <Text underline> {fullName} </Text>
        </Col>
      </Row>
      <Divider />
      <Row gutter={20}>
        <Col span={12}>
          <Text strong> Номер: </Text>
        </Col>
        <Col span={12}>
          <Text underline> {formattedNumber} </Text>
        </Col>
      </Row>
    </Card>
  )
}
